<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <div class='navContainer' style='width: 210px'>
        <p>供应商：</p>
        <el-input v-model='supplierIpt' size='mini' style='width:150px' placeholder='请输入供应商名称' />
      </div>
      <div class='navContainer'>
        <p>类型：</p>
        <el-select v-model='customerIpt' filterable size='mini' style='width:150px'
                   placeholder='请选择'>
          <el-option v-for='item in customerOption2' :key='item.id' :label='item.type_name'
                     :value='item.id' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>公司性质：</p>
        <el-select v-model='enterpriseIpt' filterable size='mini' style='width:150px'
                   placeholder='请选择'>
          <el-option v-for='item in enterpriseOption' :key='item.id' :label='item.classaName'
                     :value='item.id' />
        </el-select>
      </div>
      <div class='navContainer'>
        <p>状态：</p>
        <el-select v-model='stateIpt' filterable size='mini' style='width:150px' placeholder='请选择'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
<!--        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>-->
<!--        <el-button size='small' type='primary' @click='addBtn'>新增</el-button>-->
        <el-button size='small' type='primary' @click='synchronize'>同步数据</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <span class='el-icon-download el-icon--right'
                style='cursor:pointer;font-size: 16px;margin-right: 20px;color: rgba(51, 136, 255, 1);display: flex;align-items: center;'
                @click='download'>模板下载</span>
          <span @click='exportClick' style='cursor:pointer;font-size: 16px;'>导出数据</span>
          <span style='cursor: pointer'>
            <el-upload
              ref='upload'
              class='upload-demo'
              :action='importUrl'
              :auto-upload='true'
              :show-file-list='false'
              :data='uploadData1'
              :on-success='planOnSuccess'
              :before-upload='beforeUpload'
            >
              <i class='el-icon-upload el-icon--right'>批量导入</i>
            </el-upload>
          </span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :row-class-name='tableRowClassName'
        >
          <el-table-column type='selection' align='center' width='50'/>
          <el-table-column label='序号' align='center' width='50px'/>
          <el-table-column prop='id' label='单位内码' align='center' width='150' />
          <el-table-column prop='code' label='单位编号' align='center' width='150' />
          <el-table-column prop='name_chs' label='单位名称' align='center' width='190' show-overflow-tooltip/>
          <el-table-column prop='name_en' label='英文名称' align='center' width='130'/>
          <el-table-column prop="partnerType" label="单位类别" align="center" width='130'/>
          <el-table-column prop='taxpayerType' label='纳税人类型' align='center' width='130'/>
          <el-table-column prop="scc" label="统一社会信用代码" align="center" width="190" show-overflow-tooltip/>
          <el-table-column prop='ofCountry' label='国家' align='center' width='100'/>
          <el-table-column prop='ofRegion' label='地区' align='center' width='150'/>
          <el-table-column prop='isInsideCom' label='内部单位' align='center' width='150'>
            <template slot-scope='scope'>{{ scope.row.isInsideCom |isInsideComFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='insideCom' label='对应内部单位内码' align='center' width='150'/>
          <el-table-column prop='partnerNature' label='公司性质' align='center' width='100'/>
          <el-table-column prop='address' label='详细地址' align='center' show-overflow-tooltip width="190" />
          <el-table-column label='状态' align='center' width='100'>
            <div slot-scope='scope'>{{ getState(scope.row.status) }}</div>
          </el-table-column>
<!--          <el-table-column label='操作' :width='operationWidth' align='center'>-->
<!--            <template slot-scope='scope'>-->
<!--              <div style='display:flex;align-items:center;padding-left: 10px' class='dynamicWidth'>-->
<!--                <el-button size='mini' class='searchBtn' type='primary'-->
<!--                           @click='detailClick(scope.row.id)'>详情-->
<!--                </el-button>-->
<!--                <el-button size='mini' type='primary'-->
<!--                           @click='editBtn(scope.row.id)' class='yellow-bg'>修改-->
<!--                </el-button>-->
<!--                <el-button v-if='scope.row.status==1' size='mini' type='primary'-->
<!--                           @click='basicInfoClick(scope.row)' class='yellow-bg'>修改基础信息-->
<!--                </el-button>-->
<!--                <el-button v-if='scope.row.status==1' size='mini' type='primary'-->
<!--                           @click='changeClick(scope.row)' class='yellow-bg'>信息变更-->
<!--                </el-button>-->
<!--                <el-button v-if='scope.row.status==0' class='resetBtn' size='mini'-->
<!--                           @click='disableClick(scope.$index, scope.row)'>取消审核-->
<!--                </el-button>-->
<!--                <el-button v-if='scope.row.status==1' size='mini' type='danger'-->
<!--                           @click='enableClick(scope.row.id)'>终止合作-->
<!--                </el-button>-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
  </div>
</template>

<script>

import {getSessionStore} from "@/config/mUtils";
import {baseUrl} from "@/config/env";
import {
  getIncrement,
  getPageList,
  getMasterDate,
  getSupplierMasterDate,
} from '@/service/basicfile';
export default {
  data(){
    return{
      importLoading: false,
      btnLoading: false,
      mapVisible: false,
      mapVisible2: false,
      supplierIpt: '',
      customerIpt: '',
      enterpriseIpt: '',
      stateIpt: '',
      customerOption2: [],
      customerOption: [],
      enterpriseOption: [
        {
          id: '',
          classaName: '全部',
        },
      ],
      stateOption: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 0,
          label: '待审核',
        },
        {
          value: 1,
          label: '合作中',
        },
        {
          value: 2,
          label: '已退出',
        },
      ],
      importUrl: '',//导入地址
      uploadData1: {
        mFile: '',
      },
      uploadFlag: false,//替换
      uploadIndex: '',//替换索引
      tableLoad: false,
      TableDatas: [],
      page: 1,
      size: 10,
      total: 0,
      isInsideCom:'', //是否内部单位
    }
  },
  filters: {
    isInsideComFormat(value) {
      switch (value) {
        case 0:
          return '是';
        case 1:
          return '否';
      }
    },
  },
  methods:{
    getState() {
      return function(state) {
        switch (state) {
          case 0:
            return '停用中';
          case 1:
            return '启用中';
        }
      };
    },
    contractSizeChange(sizes) {
      this.size = sizes;
    },
    contractCurrentChange(page) {
      this.page = page;
    },
    //查询
    searchBtn(){
      this.page = 1;
      this.getPageList()
    },
    async getPageList(){
      const {
        status,
        message,
        data,
      } = await getPageList({
        page:1,
        rows:10,
      })
      if (status !== 0) return this.$message.warning(message);
      this.TableDatas = data.records;
      this.total = data.total;
    },
    // 批量导入
    planOnSuccess(res) {
      this.importLoading = false;
      // if (res.status !== 0) return this.$message.error(res.message);
      // this.$message.success(res.message);
      // this.TableDatas = res.data;
      // this._customerInfoPageList();
      this.$alert(res.message, '提示', {
        confirmButtonText: '关闭',
        callback: async () => {
          this.TableDatas = res.data;
          await this._customerInfoPageList();
        },
      });

    },
    beforeUpload(file) {
      // console.log(file);
      if (file.name.split('.')[1] == 'xls' || file.name.split('.')[1] == 'xlsx') {
        this.uploadData1.mFile = file.name;
        this.importLoading = true;
      } else {
        this.$message.error('请选择excel文件导入！！！');
        return false;
      }
    },
    //模板下载
    download() {
      // window.location.href = "/file/entrustImport.xlsx";
      this.$axios.get('/file/供应商导入模板.xlsx', {
        responseType: 'blob', //重要
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          let fname = '供应商导入模板.xlsx';
          link.href = url;
          link.setAttribute('download', fname);
          document.body.appendChild(link);
          link.click();
        });
    },
    //导出数据
    exportClick() {
      const obj = {
        customerName: this.companyIpt,
        typeId: this.customerIpt,
        customerNatureId: this.enterpriseIpt,
        status: this.stateIpt,
        rows: this.size,
        page: this.page,
      };
      // let token = getSessionStore('token');
      // window.location.href = `${baseUrl}/platform/sys/customerInfo/exportXls?access_token=${token}&customerName=${obj.customerName}&typeId=${obj.typeId}&customerNatureId=${obj.customerNatureId}&status=${obj.status}`;
      window.exportExcelGet('/platform/sys/customerInfo/exportXls', `customerName=${obj.customerName}&typeId=${obj.typeId}&customerNatureId=${obj.customerNatureId}&status=${obj.status}`)
    },
    tableRowClassName({ row }) {
      if (row.status === 2) {
        return 'ui-warning-row';
      }
    },
    //同步数据
    async synchronize() {
      this.pageLoading = true
      const {status, message} = await getSupplierMasterDate({type: 2})
      this.pageLoading = false
      if (status !== 0) return this.$message.warning(message);
      this.$message.success(message);
    },
    async getMasterDate() {
      const { status, message } =  await getMasterDate({dic:'MDMPartner'});
      if (status !== 0) return this.$message.warning(message);
      if (status === 'success') {
        await this.getPageList();
      } else {
        console.error('Error:', message);
        await this.getPageList();
      }
    },
  }
};
</script>


<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  background-color: #fff;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 10px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 10px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-loading-mask {
          z-index: 1000;
        }

        .el-badge__content {
          top: 4px !important;
          right: 1px !important;
        }

        .el-badge__content {
          background-color: #F56C6C !important;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }
      }

      &Nav {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        span {
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .depart {
    width: 100%;
    padding: 10px 40px 10px 10px;
    height: 75vh;
    overflow: auto;

    .specialSelect {
      ::v-deep {
        .el-input__inner {
          border: none;
        }
      }
    }

    .imgUp {
      .upload-demo {
        display: flex;
      }

      .upload {
        font-size: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        i {
          margin-right: 10px;
        }

        i:hover {
          color: #00e1ff;
        }
      }
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  .permissions {
    width: 100%;
    padding: 20px 10px 20px 50px;

    .name {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        color: #2F1010;
      }
    }

    .content1 {
      p {
        color: #2F1010;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  .cooperation {
    width: 100%;
    margin: 10px 20px;

    p {
      font-size: 14px;
      color: #606266;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .btnContainer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 20px;
    }
  }

  .detail {
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height: 80vh;
    overflow: auto;

    ::v-deep {
      .el-badge__content {
        top: 4px !important;
        right: 1px !important;
      }

      .el-badge__content {
        background-color: #F56C6C !important;
      }
    }

    .baseInfo {
      display: flex;
      flex-direction: column;

      .attachment {
        display: flex;
        flex-direction: column;
        padding-top: 10px;

        &Item {
          width: 80%;
          margin-bottom: 10px;
          margin-left: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            color: #969696;
            font-size: 14px;
          }
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;

        &Item {
          margin-bottom: 15px;

          .span1 {
            font-weight: 700;
          }

          span {
            font-size: 14px;
          }

          .specialOne {
            width: 50%;
          }
        }

        .specialItem {
          display: flex;
        }
      }
    }

    .operation {
      display: flex;
      flex-direction: column;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }

      &Table {
        width: 100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }

  ::v-deep {
    .tableContainerNav span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    .el-table .ui-warning-row {
      background-color: #fef0f0 !important;
    }
    .el-table .check-tr {
      background-color: #409EFF !important;
    }

    .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
      background-color: #fef0f0 !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
